module.exports = __webpack_public_path__ + "static/2-e3dfb169e2ce96178b032d283865d66d.jpg";